import { AfterViewInit, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'ig-stars',
    templateUrl: './stars.component.html',
    styleUrls: ['./stars.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class StarsComponent implements AfterViewInit {
    @Input() public rating: number;
    public colorStars = [];
    public grayStars = [];

    constructor() {
    }

    public ngAfterViewInit() {
        if (this.rating) {
            let times = Math.floor(this.rating);
            for (let i = 0; i < times; i++) {
                this.colorStars.push({});
            }
            let grayTimes = 5 - times;
            for (let i = 0; i < grayTimes; i++) {
                this.grayStars.push({});
            }
        }
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/stars/stars.component.ts